export interface DecodedDataUri {
  readonly bytes: Uint8Array
  readonly mimeType: string
}

function decodePercentEncodedBytes(payload: string): Uint8Array {
  const bytes: number[] = []
  for (let index = 0; index < payload.length; index += 1) {
    const value = payload[index]
    if (value === '%') {
      const encoded = payload.slice(index + 1, index + 3)
      if (!/^[0-9a-f]{2}$/iu.test(encoded)) {
        throw new Error(`data URI 含无效百分号编码: %${encoded}`)
      }
      bytes.push(Number.parseInt(encoded, 16))
      index += 2
      continue
    }

    const codePoint = payload.codePointAt(index)!
    if (codePoint <= 0x7f) {
      bytes.push(codePoint)
      continue
    }
    const character = String.fromCodePoint(codePoint)
    bytes.push(...new TextEncoder().encode(character))
    index += character.length - 1
  }
  return new Uint8Array(bytes)
}

/** 按 RFC 2397 语义解码 data URI，百分号转义始终映射为单个原始字节。 */
export function decodeDataUri(uri: string): DecodedDataUri {
  const separator = uri.indexOf(',')
  if (separator < 0 || !uri.startsWith('data:')) {
    throw new Error('data URI 格式无效')
  }
  const metadata = uri.slice(5, separator)
  const mimeType = metadata.split(';')[0] || 'application/octet-stream'
  const payload = uri.slice(separator + 1)
  if (metadata.split(';').includes('base64')) {
    const binary = atob(payload)
    const bytes = new Uint8Array(binary.length)
    for (let index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index)
    }
    return { bytes, mimeType }
  }
  return { bytes: decodePercentEncodedBytes(payload), mimeType }
}
